/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Google_PlayInputs */

const en_downloads_google_play = /** @type {(inputs: Downloads_Google_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get it on Google Play`)
};

const es_downloads_google_play = /** @type {(inputs: Downloads_Google_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener en Google Play`)
};

/**
* | output |
* | --- |
* | "Get it on Google Play" |
*
* @param {Downloads_Google_PlayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_google_play = /** @type {((inputs?: Downloads_Google_PlayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Google_PlayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_google_play(inputs)
	return en_downloads_google_play(inputs)
});